import styled from 'styled-components';
import { StyledCell } from '../styled';

export const StyledShipperCell = styled(StyledCell)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledTags = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0;
`;
export const StyledShipperCellContainer = styled.div`
  position: relative;
`;
